import { useEffect } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { track } from 'ui-addon-upgrades/_core/common/eventTracking/tracker';
import UIButton from 'UIComponents/button/UIButton';
import { ContextualPromptConfig } from '../../constants/trials';
import BasePrompt from '../../trial/prompts/BasePrompt';
import { hasCopilotHookPromptGate } from '../../utils/gates';
import { ContextualAITrialPrompt } from './ContextualAITrialPrompt';
import { jsx as _jsx } from "react/jsx-runtime";
const getUpgradeData = (upgradeProduct, app, promptType) => ({
  app,
  screen: 'index',
  uniqueId: `trial-${promptType}`,
  upgradeProduct
});
const ContextualTrialPrompt = ({
  app,
  activeTrials,
  expiredTrials,
  isMultiTrial,
  upgradeProduct,
  setShowPrompt
}) => {
  // @ts-expect-error ts-migrate(2538) FIXME: Type 'undefined' cannot be used as an index type.
  const {
    href,
    promptType
  } = ContextualPromptConfig[upgradeProduct][app];
  useEffect(() => {
    track('trialActionPromptInteraction', Object.assign({
      action: 'viewed contextual prompt'
    }, getUpgradeData(upgradeProduct, app, promptType), {
      isMultiTrial,
      activeTrials,
      expiredTrials
    }));
  }, [app, upgradeProduct, promptType, isMultiTrial, activeTrials, expiredTrials]);
  const handleClose = () => {
    track('trialActionPromptInteraction', Object.assign({
      action: 'closed contextual prompt'
    }, getUpgradeData(upgradeProduct, app, promptType), {
      isMultiTrial,
      activeTrials,
      expiredTrials
    }));
    if (setShowPrompt) {
      setShowPrompt(false);
    }
  };
  const onCtaClick = () => {
    track('trialActionPromptInteraction', Object.assign({
      action: 'clicked contextual prompt'
    }, getUpgradeData(upgradeProduct, app, promptType), {
      isMultiTrial,
      activeTrials,
      expiredTrials
    }));
  };
  if (app && hasCopilotHookPromptGate()) {
    return /*#__PURE__*/_jsx(ContextualAITrialPrompt, {
      app: app
    });
  }
  return /*#__PURE__*/_jsx(BasePrompt, {
    dataTestId: 'contextual-trial-prompt',
    headerText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `trial-components-library.trialPrompts.guidance.${upgradeProduct}.${app}.title`
    }),
    bodyText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `trial-components-library.trialPrompts.guidance.${upgradeProduct}.${app}.body`
    }),
    cta: /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": 'contextual-trial-prompt-cta',
      use: "primary",
      onClick: onCtaClick,
      href: href,
      external: true,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "trial-components-library.trialPrompts.cta.learnMore"
      })
    }),
    handleClose: handleClose
  });
};
export default ContextualTrialPrompt;